import * as React from 'react';
import { useDayPicker } from '..';
import { NavigationContext } from "./NavigationContext";
import { useNavigationState } from "./useNavigationState";
import { getDisplayMonths } from "./utils/getDisplayMonths";
import { getNextMonth } from "./utils/getNextMonth";
import { getPreviousMonth } from "./utils/getPreviousMonth";
/** Provides the values for the [[NavigationContext]]. */

export function NavigationProvider(props) {
  var context = useDayPicker();

  var _a = useNavigationState(),
      month = _a[0],
      goToMonth = _a[1];

  var displayMonths = getDisplayMonths(month, context);
  var nextMonth = getNextMonth(month, context);
  var previousMonth = getPreviousMonth(month, context);
  return /*#__PURE__*/React.createElement(NavigationContext.Provider, {
    value: {
      month: month,
      displayMonths: displayMonths,
      goToMonth: goToMonth,
      previousMonth: previousMonth,
      nextMonth: nextMonth
    }
  }, props.children);
}